import { animate, query, sequence, stagger, style, transition, trigger } from "@angular/animations";

export const dropDown = trigger('dropDown', [
  transition(':enter', [
    style({ height: 0 }),
    query('.anim-item', [
      style({ opacity: 0, transform: 'translateX(-150px)' })
    ], { optional: true }),
    sequence([
      animate('50ms', style({ height: '*' })),
      query('.anim-item', [
        stagger(-50, [
          animate('100ms ease', style({ opacity: 1, transform: 'none' }))
        ])
      ], { optional: true })
    ])
  ]),

  transition(':leave', [
    style({ height: '*' }),
    query('.anim-item', [style({ opacity: 1, transform: 'none' })], { optional: true }),
    sequence([
      query('.anim-item', [
        stagger(50, [
          animate(
            '100ms ease',
            style({ opacity: 0, transform: 'translateY(-150px)' })
          )
        ])
      ], { optional: true }),
      animate('50ms', style({ height: 0 }))
    ])
  ])
]);
